<div class="content-wrapper">
  <div class="row"></div>
  <div class="row">
    <section id="selection-n-deletion">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="headerGlobal"><h6 class="text-white ml-2 title-header headerGlobalTitle">Liste Produits non saisis</h6></div>
            <div *ngIf="filteredProducts" class="card-content">
                <div class="card-body engineCss">
                  <form #SearchEngineForm="ngForm" name="SearchEngineForm" id="SearchEngineForm" >
                    <!-- ligne 1 -->
                    <div class="row" style="display: flex!important;">
                      <!-- Code produit -->
                      <div class="col-md-2">
                        <div class="form-floating">
                          <label for="productCode">Code produit</label>
                          <input class="form-control" id="productCode" name="productCode" [(ngModel)]="productCode" type="text" placeholder="Code produit">
                        </div>
                      </div>
                      <!-- Code forfait -->
                      <div class="col-md-2">
                        <div class="form-floating">
                          <label for="packageCode">Code forfait</label>
                          <input class="form-control" id="packageCode" name="packageCode" [(ngModel)]="packageCode" type="text" placeholder="Code forfait">
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-floating">
                          <label>&nbsp;</label>
                          <div class="w-auto d-block">
                            <button class="btn btn-primary" name="btnRecherche" id="btnRecherche" (click)="rechercher()">
                              <i class="ft-search mr-1"></i>Rechercher
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              <div class="card-body">
                <div class="table-responsive" *ngIf="filteredProducts?.length != 0">
                  <table class="table table-striped table-bordered selection-deletion-row mt-2 tableList" matSort (matSortChange)="sortData($event)">
                    <thead >
                    <tr>
                      <th mat-sort-header="code" style="width: 33% !important;">Référence</th>
                      <th style="width: 33% !important;">Importer produit</th>
                      <th style="width: 33%">Importer forfait</th>
                    </tr>
                    </thead>
                    <tbody *ngIf="filteredProducts?.length == 0">
                    <img class="LoaderImages" src="../assets/img/load.gif" style="position: inherit; margin: 15px;">
                    </tbody>
                    <tbody *ngIf="(filteredProducts?.length != 0 && filteredProducts.products?.length != 0)">
                    <tr *ngFor="let item of filteredProducts.products">
                      <td style="width: 33% !important;">{{item.CODE}}</td>
                      <td style="width: 33% !important;"><button class="btn btn-info mr-1" style="width: 250px;" (click)="importer('product',item.CODE)"><i class="ft-arrow-down"></i>&nbsp;importer {{item.CODE}}</button> </td>
                      <td style="width: 33% !important;">
                        <span class="listOverFlow">
                          <li *ngFor="let package of item.PACKAGES">
                            <button class="btn btn-success mr-1  pckagesBtn" style="width: 250px;" (click)="importer('package',package.CODE)"><i class="ft-arrow-down"></i>&nbsp;importer {{package.CODE}}</button>
                          </li>
                        </span>

                      </td>
                    </tr>
                    </tbody>
                    <tbody *ngIf="filteredProducts?.length != 0 && filteredProducts.packages?.length != 0" style="border: 2px solid #40c057;">
                    <tr *ngFor="let item of filteredProducts.packages">
                      <td style="width: 33% !important;">{{item.CODE}}</td>
                      <td style="width: 33% !important;"></td>
                      <td style="width: 33% !important;">
                        <button class="btn btn-success mr-1 pckagesBtn" style="width: 250px;" (click)="importer('package',item.CODE)"><i class="ft-arrow-down"></i>&nbsp;importer {{item.CODE}}</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
